import { cn } from '@/lib/utils'

interface GridSkeletonProps {
  count?: number
  columns?: number
  aspectRatio?: string
  className?: string
}

export function GridSkeleton({
  count = 6,
  columns = 3,
  aspectRatio = 'aspect-video',
  className,
}: GridSkeletonProps) {
  return (
    <div
      className={cn('grid gap-3', className)}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          className={cn('rounded-lg bg-white/[0.03] animate-pulse', aspectRatio)}
        />
      ))}
    </div>
  )
}
